import React from 'react';

import { ArrowRight, Faq } from '@travel/icons/ui';
import { Link } from '@travel/ui';

import styles from './domesticErrorPage.module.scss';

type Props = {
  text: string;
  url: string;
};

function FaqLink(props: Props) {
  return (
    <Link
      url={props.url}
      className={styles.faqItem}
      label={
        <>
          <Faq size={20} className={styles.faqIcon} />
          <span className={styles.faqText}>{props.text}</span>
          <ArrowRight size={16} className={styles.faqIcon} />
        </>
      }
    />
  );
}

export default FaqLink;
